<template>
    <div class="skillInfo assessment-mb" :class="{'skillInfoPC':$store.state.innerWidth>768}">
      <div class="topic-pc">
         <div class="info-content">
             <div>
                 <h2 class="Bold mainColor center">{{$t('message.Background-Career Quiz')}}</h2>
                 <p class="dscr pad-b-10 center">{{$t('message.backgroundDesc')}}</p>
             </div>
         </div>
         <div class="li-content">
             <div>
                 <div class="startBtn">
                    <div class="btn btn-primary" @click="startEvent()" role="button" :aria-label="$t('message.Start')">
                        <a href="javascript:;" style="color: inherit">{{$t('message.Start')}}</a>
                    </div>
                 </div>
             </div>
         </div>
                 <a class="displayA" v-bind:href="'./backgroundTopic?lang='+$store.state.language"></a>
       </div>
    </div>
</template>
<script>
import Breadcrumbs from '@/components/Breadcrumbs'
export default {
    components: {
       Breadcrumbs
    },
    data() {
        return {
            
        }
    },   
    props: ["logGaEvent"],
    created(){
    },
    methods: {
      startEvent:function(){
          this.logGaEvent('userClick','backgroundInfo',"backgroundTopic")
        this.$router.push({ path: '/backgroundTopic', query:{lang:this.$store.state.language} });
         window.scrollTo(0, 0);
      }
    },
    mounted() {
        this.$store.state.selectMenu =5;
        this.$store.state.mate.title = this.$i18n.t("message.Self-Assessment")+" - talent.gov.hk"
    }


   
}
</script>